import { FC, ReactNode } from 'react';
import classNames from 'classnames';

export interface MeetLayoutVideosTopPanelBottomProps {
  /** Верхняя секция (сетка видео участников) */
  topContent: ReactNode;
  /** Нижняя секция (показ экрана, выбор колоды МАК и т.д.) */
  bottomContent: ReactNode;
  /** При true два ряда участников (>6): верх 30%, низ 70%; иначе один ряд: верх 15%, низ 85% */
  topSectionLarge?: boolean;
  /** Дополнительный класс для нижней секции (например фон) */
  bottomClassName?: string;
  /** При true нижняя панель на всю высоту поверх видео (overlay) */
  bottomExpanded?: boolean;
  /** Переключить развёрнутое состояние нижней панели */
  onBottomExpandToggle?: () => void;
  /** Слой поверх нижней секции (демонстрация экрана при активном инструменте) */
  bottomOverlay?: ReactNode;
}

/**
 * Layout встречи: видео сверху, панель контента снизу.
 * Используется для screen share и для инструмента МАК в групповой терапии.
 */
export const MeetLayoutVideosTopPanelBottom: FC<MeetLayoutVideosTopPanelBottomProps> = ({
  topContent,
  bottomContent,
  topSectionLarge = false,
  bottomClassName,
  bottomExpanded = false,
  onBottomExpandToggle,
  bottomOverlay,
}) => (
  <div className="relative h-full w-full flex flex-col gap-2">
    <div className="flex-shrink-0 w-full min-h-[120px]">
      {topContent}
    </div>
    <div
      className={classNames(
        'min-h-0 w-full rounded-[5px] md:rounded-[15px] overflow-hidden',
        bottomClassName,
        bottomExpanded ? 'absolute inset-0 z-[60] flex flex-col' : 'relative flex-1',
      )}
    >
      <div
        className={classNames('h-full w-full min-h-0', {
          'opacity-0 pointer-events-none': bottomOverlay,
        })}
      >
        {bottomContent}
      </div>
      {onBottomExpandToggle && (
        <button
          type="button"
          onMouseDown={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onBottomExpandToggle();
          }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
          className="absolute right-[58px] top-5 z-[120] flex items-center gap-1.5 rounded px-2 py-1 font-manrope text-sm text-[#2C3038] pointer-events-auto hover:bg-[#E5E5E5] hover:text-[#585858]"
          aria-label={bottomExpanded ? 'Свернуть панель' : 'Расширить панель'}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 shrink-0" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zm-3-12v2h3v3h2V5h-5z" />
          </svg>
          {bottomExpanded ? 'Свернуть' : 'Расширить'}
        </button>
      )}
      {bottomOverlay && <div className="absolute inset-0 z-10">{bottomOverlay}</div>}
    </div>
  </div>
);
